import { render, staticRenderFns } from "./SmsVerification.vue?vue&type=template&id=0fec0a10&scoped=true"
import script from "./SmsVerification.vue?vue&type=script&lang=js"
export * from "./SmsVerification.vue?vue&type=script&lang=js"
import style0 from "./SmsVerification.vue?vue&type=style&index=0&id=0fec0a10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec0a10",
  null
  
)

export default component.exports